import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from "../Tabs/Tabs";
import FeePresenterTabContent from  "./FeePresenterTabContent";

export default class FeePresenter extends React.Component {
  constructor(props) {
    super(props)
    var unit;
 

    this.state = {
      active_tab: 'general',
    };

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
  };

  componentDidMount() {
    var self = this
    $(window).on("feeSaved", function () {
      $.ajax({
        type: 'POST',
        url: `/admin/fees/${self.props.id}/data`,
      }).done((data) => {
        self.setState({...data});
      })
    });
  }

  render() {
    var self = this;

    var buttons = [
      {
        name: I18n.t('ok'),
        html_attributes: ['data-dismiss="modal"']
      }
    ]

    return(
      <div className="fee-builder" ref="root">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <FeePresenterTabContent {...this.props}
            active_tab={this.state.active_tab}
           />
        </div>
      </div>
    )
  }

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab})
  };

  // tabs() {
  //   if(this.props.historical_version == true) {
      
  //     return (
  //       [
  //         {
  //           tabName: I18n.t('general'),
  //           targetName: 'general',
  //           classes: this.state.active_tab === 'general' ? 'active' : null,
  //           changeHandler: this.onChangeActiveTab,
  //         },
  //       ]
  //     )

  //   } else {

  //     return (
  //       this.props.tax
  //         ?
  //         [
  //           {
  //             tabName: I18n.t('general'),
  //             targetName: 'general',
  //             classes: this.state.active_tab === 'general' ? 'active' : null,
  //             changeHandler: this.onChangeActiveTab,
  //           },
  //           {
  //             tabName: I18n.t('rates'),
  //             targetName: 'rates',
  //             classes: this.state.active_tab === 'rates' ? 'active' : null,
  //             changeHandler: this.onChangeActiveTab,
  //           },
  //           {
  //             tabName: I18n.t('products'),
  //             targetName: 'products',
  //             classes: this.state.active_tab === 'products' ? 'active' : null,
  //             changeHandler: this.onChangeActiveTab,
  //           },
  //           {
  //             tabName: I18n.t('cancellation_rules'),
  //             targetName: 'cancellation_rules',
  //             classes: this.state.active_tab === 'cancellation_rules' ? 'active' : null,
  //             changeHandler: this.onChangeActiveTab,
  //           },
  //           {
  //             tabName: I18n.t('guest_types'),
  //             targetName: 'guest_types',
  //             classes: this.state.active_tab === 'guest_types' ? 'active' : null,
  //             changeHandler: this.onChangeActiveTab,
  //           },
  //           {
  //             tabName: I18n.t('fees'),
  //             targetName: 'fees',
  //             classes: this.state.active_tab === 'fees' ? 'active' : null,
  //             changeHandler: this.onChangeActiveTab,
  //           },
  //           {
  //             tabName: I18n.t('history'),
  //             targetName: 'history',
  //             classes: this.state.active_tab === 'history' ? 'active' : null,
  //             changeHandler: this.onChangeActiveTab,
  //           }
  //         ]
  //         :
  //         [
  //           {
  //             tabName: I18n.t('general'),
  //             targetName: 'general',
  //             classes: this.state.active_tab === 'general' ? 'active' : null,
  //             changeHandler: this.onChangeActiveTab,
  //           },
  //           {
  //             tabName: I18n.t('rates'),
  //             targetName: 'rates',
  //             classes: this.state.active_tab === 'rates' ? 'active' : null,
  //             changeHandler: this.onChangeActiveTab,
  //           },
  //           {
  //             tabName: I18n.t('products'),
  //             targetName: 'products',
  //             classes: this.state.active_tab === 'products' ? 'active' : null,
  //             changeHandler: this.onChangeActiveTab,
  //           },
  //           {
  //             tabName: I18n.t('taxes'),
  //             targetName: 'taxes',
  //             classes: this.state.active_tab === 'taxes' ? 'active' : null,
  //             changeHandler: this.onChangeActiveTab,
  //           },
  //           {
  //             tabName: I18n.t('history'),
  //             targetName: 'history',
  //             classes: this.state.active_tab === 'history' ? 'active' : null,
  //             changeHandler: this.onChangeActiveTab,
  //           }
  //         ]
  //     );
  //   }
  // };

  tabs() {
    let guest = false
    var unit;
    if (this.props.tax_fee_unit) {
      // console.log("this.props.tax_fee_unit", this.props.tax_fee_unit);

      if (this.props.tax_fee_unit.ru_id == "1") {
        unit = "room_per_stay"
      } else if (this.props.tax_fee_unit.ru_id == "2") {
        unit = "room_per_day"
      } else if (this.props.tax_fee_unit.ru_id == "5") {
        unit = "guest_per_stay"
      } else if (this.props.tax_fee_unit.ru_id == "6") {
        unit = "guest_per_day"
      } else {
        unit = null
      }
    } else {
      unit = null
    }
    if (unit == "guest_per_stay" || unit == "guest_per_day") {
      guest = true
    }
    // console.log("unit", unit, guest);

    if (this.props.new_record && this.props.tax && guest ){
      return(
        [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,

          },
          {
            tabName: I18n.t("rates"),
            targetName: "rates",
            classes: this.state.active_tab === "rates" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("products"),
            targetName: "products",
            classes: this.state.active_tab === "products" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          // {
          //   tabName: I18n.t("guest_types"),
          //   targetName: "guest_types",
          //   classes: this.state.active_tab === "guest_types" ? "active" : null,
          //   changeHandler: this.onChangeActiveTab,
          // },
          {
            tabName: I18n.t("fees"),
            targetName: "fees",
            classes: this.state.active_tab === "fees" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      )
    } else if (this.props.new_record && this.props.tax) {
      return(
        [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,

          },
          {
            tabName: I18n.t("rates"),
            targetName: "rates",
            classes: this.state.active_tab === "rates" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("products"),
            targetName: "products",
            classes: this.state.active_tab === "products" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("fees"),
            targetName: "fees",
            classes: this.state.active_tab === "fees" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      )
    } else if (this.props.tax && !this.props.new_record && guest) {
      return(
        [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,

          },
          {
            tabName: I18n.t("rates"),
            targetName: "rates",
            classes: this.state.active_tab === "rates" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("products"),
            targetName: "products",
            classes: this.state.active_tab === "products" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },

          // {
          //   tabName: I18n.t("guest_types"),
          //   targetName: "guest_types",
          //   classes: this.state.active_tab === "guest_types" ? "active" : null,
          //   changeHandler: this.onChangeActiveTab,
          // },
          {
            tabName: I18n.t("tasks"),
            targetName: "tasks",
            classes: this.state.active_tab === "tasks" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      )


    } else if (this.props.tax) {
      return(
        [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,

          },
          {
            tabName: I18n.t("rates"),
            targetName: "rates",
            classes: this.state.active_tab === "rates" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("products"),
            targetName: "products",
            classes: this.state.active_tab === "products" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("fees"),
            targetName: "fees",
            classes: this.state.active_tab === "fees" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("tasks"),
            targetName: "tasks",
            classes: this.state.active_tab === "tasks" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
        ]
      )
    } else if (guest && this.props.calculate_by_guest_type) {
      
      return(
        [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,

          },
          {
            tabName: I18n.t("rates"),
            targetName: "rates",
            classes: this.state.active_tab === "rates" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },

          {
            tabName: I18n.t("taxes"),
            targetName: "taxes",
            classes: this.state.active_tab === "taxes" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("guest_types"),
            targetName: "guest_types",
            classes: this.state.active_tab === "guest_types" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t("tasks"),
            targetName: "tasks",
            classes: this.state.active_tab === "tasks" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },

        ]
      )
    } else {
      return(
        [
          {
            tabName: I18n.t("general"),
            targetName: "general",
            classes: this.state.active_tab === "general" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          
          },
          {
            tabName: I18n.t("rates"),
            targetName: "rates",
            classes: this.state.active_tab === "rates" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },

          {
            tabName: I18n.t("taxes"),
            targetName: "taxes",
            classes: this.state.active_tab === "taxes" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },

          {
            tabName: I18n.t("tasks"),
            targetName: "tasks",
            classes: this.state.active_tab === "tasks" ? "active" : null,
            changeHandler: this.onChangeActiveTab,
          },

        ]
      )
    }
  }

};
